export const manualNightlyProcessSuccess = 'Manual nightly process succeeded';
export const removeTenantSuccess = 'Tenant removed. Performing logout now';
export const tenantLocked = 'Tenant currently locked. Did not perform action.';
export const noUsers = 'Dieses Hotel hat keine Benutzer.';

export const apaleoConnectSuccess = 'Successfully connected to Apaleo';
export const apaleoConnectFailed = 'Error while connecting to Apaleo';
